const OFFER_LRX = 'lrx';
const LRX_UTM_CAMPAIGN = 'lrx_web_acquisition';

export { OFFER_LRX, LRX_UTM_CAMPAIGN };
